.message-content-block-data {
  width: 100%;
  min-height: 24px;
  line-height: 1.5rem;
  font-weight: 500;
  display: inline-block;
  overflow-wrap: break-word;
}

.message-content-block-data p {
  margin: 0;
  padding: 0;
  line-height: 1.5rem;
  font-size: 16px;
  font-weight: 400;
  overflow-wrap: break-word;
  display: inline-block;
  vertical-align: top;
}

.message-content-block-data :not(pre):not(code) {
  font-size: 16px;
  font-weight: 400;
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;
}

.message-content-block-data p ~ table,
.message-content-block-data p ~ .code-block {
  margin-top: 15px !important;
}

.message-content-block-data .code-block ~ p {
  margin-top: 5px !important;
}

.message-content-block-data table ~ p {
  margin-top: 10px !important;
}

.message-content-block-data em {
  font-style: italic;
}

.message-content-block-data strong {
  font-weight: 700;
}

.message-content-block-data strike,
.message-content-block-data del {
  text-decoration: line-through;
}

.message-content-block-data h1 {
  font-size: 18px;
  font-weight: 700;
  margin-top: 0.5rem;
  margin-bottom: 15px;
}

.message-content-block-data h1 * {
  font-size: 18px !important;
}

.message-content-block-data h2 {
  font-size: 16px;
  font-weight: 700;
  margin-top: 0.5rem;
  margin-bottom: 15px;
}

.message-content-block-data h2 * {
  font-size: 16px !important;
}

.message-content-block-data h3 {
  font-size: 15px;
  font-weight: 600;
  margin-top: 0.5rem;
  margin-bottom: 15px;
}

.message-content-block-data h3 * {
  font-size: 15px !important;
}

.message-content-block-data ul,
.message-content-block-data ol {
  padding-left: 40px;
  margin: 0.5rem 0;
}

.message-content-block-data ul li,
.message-content-block-data ol li {
  margin-bottom: 10px;
  display: list-item !important;
}

/* code with no specific language PRE */
.message-content-block-data pre:not([class]) {
  padding: 1em;
  margin: 0.5em 0;
  overflow: auto;
  border-radius: 8px !important;
  font-family: Consolas,Monaco,'Andale Mono','Ubuntu Mono',monospace !important;
}

/* code with no specific language CODE */
.message-content-block-data pre:not([class]),
.message-content-block-data pre:not([class]) code:not([class]) {
  font-family: Consolas,Monaco,'Andale Mono','Ubuntu Mono',monospace;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}

.message-content-block-data pre:not([class]),
.message-content-block-data pre:not([class]) code:not([class]) {
  color: #fff;
  text-shadow: 0 1px #000;
}

:root:not([theme='gab-muted']):not([theme='gab-night']):not([theme='gab-black']) .message-content-block-data pre:not([class]),
:root:not([theme='gab-muted']):not([theme='gab-night']):not([theme='gab-black']) .message-content-block-data pre:not([class]) code:not([class]) {
  color: #000;
  text-shadow: 0 1px #fff;
}

.message-content-block-data table {
  width: 100%;
  border-radius: 8px;
  border: 0;
  overflow: hidden;
  border-collapse: collapse;
  margin-top: 5px;
  margin-bottom: 5px;
}

.message-content-block-data thead tr th {
  text-align: left;
  padding: 5px 20px 5px 10px;
  font-size:14px;
  font-weight: 600;
}

.message-content-block-data thead tr th:last-of-type {
  border-right: 0 !important;
}

.message-content-block-data tbody tr td {
  text-align: left;
  font-size:14px;
  padding: 5px 20px 5px 10px;
}

.message-content-block-data tbody tr td:last-of-type {
  border-right: 0 !important;
}

.message-content-block-data tbody tr:last-of-type td {
  border-bottom: 0 !important;
}

/* inline code */
.message-content-block-data code:not([class]) {
  font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  -moz-tab-size: 4;
  -o-tab-size: 4;
  tab-size: 4;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
  padding: 0.1em 0.2em 0.05em;
  border-radius: 0.3em;
}

/* Code blocks - scrollable when content overflows */
.code-block-interactive {
  overflow: auto;
}

.code-block-interactive pre,
.code-block-interactive code {
  overflow: auto;
}

/* Table horizontal scroll - always show scrollbar so users know they can scroll */
.table-scroll-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(128, 128, 128, 0.5) transparent;
}

.table-scroll-container::-webkit-scrollbar {
  height: 8px;
  display: block;
}

.table-scroll-container::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.table-scroll-container::-webkit-scrollbar-thumb {
  background: rgba(128, 128, 128, 0.45);
  border-radius: 4px;
}

.table-scroll-container::-webkit-scrollbar-thumb:hover {
  background: rgba(128, 128, 128, 0.7);
}